import { render, staticRenderFns } from "./CardMeasurementDetailed.vue?vue&type=template&id=dab01082"
import script from "./CardMeasurementDetailed.vue?vue&type=script&lang=js"
export * from "./CardMeasurementDetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports